/*
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-11-17 17:42:51
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-08 15:54:35
 * @FilePath: \wanguo_web\common_web\src\api\addDevice.js
 */


import request from '@/router/axios'

//获取中介购机时报表
export function intermediaryBuyMachinehourReport(params) {
  return request({
    url: '/api/shopBuyMachinehour/intermediary/listByTime',
    method: 'get',
    params
  })
}
//修改客服信息
export function customerServiceCenterUpdate(obj) {
  return request({
    url: '/api/customer-service-center',
    method: 'put',
    data: obj
  })
}
//获取客服信息
export function customerServiceCenter(query) {
  return request({
    url: '/api/customer-service-center/role-type',
    method: 'get',
    params: query
  })
}
export function codeList(query) {
  return request({
    url: '/api/shopApplyDevice/code/list',
    method: 'get',
    params: query
  })
}


export function shopApplyDevicePage(query) {
  return request({
    url: '/api/shopApplyDevice/page',
    method: 'get',
    params: query
  })
}

export function shopApplyDevicedetail(query) {
  return request({
    url: `/api/shopApplyDevice/${query.id}`,
    method: 'get',

  })
}

// 装机总代审核

export function shopApplyDevicecheck(obj) {
  return request({
    url: '/api/shopApplyDevice/general/check',
    method: 'post',
    data: obj
  })
}


// 维保装机工单

export function getReport(query) {
  return request({
    url: '/api/maintenanceInstallationOrder/get-report',
    method: 'get',
    params: query
  })
}

export function installationTime(query) {
  return request({
    url: '/api/maintenance/get-installation-time',
    method: 'get',
    params: query
  })
}

export function setinstallationTime(obj) {
  return request({
    url: '/api/maintenance/set-installation-time',
    method: 'put',
    data: obj
  })
}

// 维修工单
export function getmainReport(query) {
  return request({
    url: '/api/maintenanceRepairOrder/get-report',
    method: 'get',
    params: query
  })
}

export function maininstallationTime(query) {
  return request({
    url: '/api/maintenance/get-repair-time',
    method: 'get',
    params: query
  })
}
export function mainsetinstallationTime(obj) {
  return request({
    url: '/api/maintenance/set-repair-time',
    method: 'put',
    data: obj
  })
}

// 换机
export function maintenancechangePage(query) {
  return request({
    url: '/api/maintenance-apply-change/pag-device',
    method: 'get',
    params: query
  })
}

export function maintenancecheck(query) {
  return request({
    url: `/api/maintenance-apply-change/check/${query.id}`,
    method: 'put',

  })
}
export function productPage(query) {
  return request({
    url: '/api/general/warehouse/list-product',
    method: 'get',
    params: query
  })
}
export function updatenumber(query) {
  return request({
    url: `/api/general/warehouse/update-device-number`,
    method: 'put',
    data:query
  })
}

export function maintenancebinduser(query) {
  return request({
    url: '/api/maintenance/exist-bind-maintenance',
    method: 'get',
    params: query
  })
}


//订单列表
export function generalItemOrderPage(query) {
  return request({
    url: '/api/generalItemOrder/page',
    method: 'get',
    params: query
  })
}

export function generalItemOrderdetail(query) {
  return request({
    url: `/api/generalItemOrder/${query.id}`,
    method: 'get',

  })
}

export function generalItemOrderPost(obj) {
  return request({
    url: '/api/generalItemOrder',
    method: 'post',
    data: obj
  })
}


//确认收货

export function generalItemOrderReceive(obj) {
  return request({
    url: '/api/generalItemOrder/receive',
    method: 'post',
    data: obj
  })
}

//取消订单

export function generalItemOrderCancel(obj) {
  return request({
    url: '/api/generalItemOrder/cancel',
    method: 'post',
    data: obj
  })
}


// 仓库订单

//分页
export function generalPage(query) {
  return request({
    url: '/api/general/warehouse/order/page',
    method: 'get',
    params: query
  })
}

export function generaldetail(query) {
  return request({
    url: `/api/general/warehouse/order/detail`,
    method: 'get',
    params: query
  })
}

//发货

export function generalshopsend(obj) {
  return request({
    url: '/api/shopItemOrder/send',
    method: 'post',
    data: obj
  })
}

export function generalshopApplyDevicesend(query) {
  return request({
    url: `/api/shopApplyDevice/send?flag=${query.selval}`,
    method: 'post',
    data: query
  })
}

// 总代查看 店铺订单

//订单列表
export function shopItemOrderPage(query) {
  return request({
    url: '/api/shopItemOrder/page',
    method: 'get',
    params: query
  })
}

export function shopItemOrderdetail(query) {
  return request({
    url: `/api/shopItemOrder/${query.id}`,
    method: 'get',

  })
}

//确认收货

export function shopItemOrdercheck(obj) {
  return request({
    url: '/api/shopItemOrder/check',
    method: 'post',
    data: obj
  })
}
export function factoryCheck(obj) {
  return request({
    url: `/api/shopApplyDevice/factory-check?id=${obj.businessId}`,
    method: 'post',
    data: obj
  })
}

// 购物车

//订单列表
export function generalItemShoppingPage(query) {
  return request({
    url: '/api/generalItemShopping/page',
    method: 'get',
    params: query
  })
}

export function getArchiveStatus(query) {
  return request({
    url: '/api/shopArchive/getArchiveStatus',
    method: 'get',
    params: query
  })
}

export function generalItemShoppingdetail(query) {
  return request({
    url: `/api/generalItemShopping/${query.id}`,
    method: 'get',

  })
}

export function generalItemShoppingcode(query) {
  return request({
    url: `/api/generalArchive/baseinfo/by/code`,
    method: 'get',

  })
}
export function shopArchiveCode(query) {
  return request({
    url: `/api/shopArchive/baseinfo/by/code`,
    method: 'get',

  })
}

//删除

export function generalItemShoppingdel(obj) {
  return request({
    url: `/api/generalItemShopping/${query.id}`,
    method: 'delete',
    data: obj
  })
}


// 报修工单

export function shopAlarmPage(query) {
  return request({
    url: '/api/shopAlarm/page',
    method: 'get',
    params: query
  })
}

// 提醒

export function shopAlarmarea(query) {
  return request({
    url: `/api/shopAlarm/warn/area`,
    method: 'post',
    data: query
  })
}


export function shopAlarmput(query) {
  return request({
    url: `/api/shopAlarm`,
    method: 'put',
    data: query
  })
}


//新增

export function shopAlarmadd(obj) {
  return request({
    url: `/api/shopAlarm`,
    method: 'post',
    data: obj
  })
}

export function shopAlarmdetail(query) {
  return request({
    url: `/api/shopAlarm/${query.id}`,
    method: 'get',

  })
}

export function shopAlarmsub(obj) {
  return request({
    url: `/api/shopAlarm/shop/submit`,
    method: 'post',
    data: obj
  })
}
// 产品列表
export function productList(query) {
  return request({
    url: '/api/product/list',
    method: 'get',
    params: query
  })
}
// 故障列表
export function alarmCommonExplainList(query) {
  return request({
    url: '/api/alarmCommonExplain/listAlarmType',
    method: 'get',
    params: query
  })
}
// 店铺列表
export function shopArchiveList(query) {
  return request({
    url: '/api/shopArchive/baseinfo/list',
    method: 'get',
    params: query
  })
}
export function shopMac(query) {
  return request({
    url: '/api/shopAlarm/get-shop-by-mac',
    method: 'get',
    params: query
  })
}
export function shopAlarmcheck(obj) {
  return request({
    url: `/api/shopAlarm/factory-check/${obj.id}`,
    method: 'put',

  })
}

// 取消报修工单
export function shopAlarmcancel(obj) {
  return request({
    url: '/api/shopAlarm/cancel',
    method: 'post',
    data: obj
  })
}

export function shopAlarmdevList(query) {
  return request({
    url: '/api/shopAlarm/list-device',
    method: 'get',
    params: query
  })
}


export function shopArchiveInfo(query) {
  return request({
    url: '/api/shopArchive/baseinfo/by/code',
    method: 'get',
    params: query
  })
}

export function putfile(obj) {
  return request({
    url: `/api/blade-resource/oss/endpoint/put-file`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: obj
  })
}


// 银行卡
export function generalArchiveBanklist(query) {
  return request({
    url: '/api/generalArchiveBank/list',
    method: 'get',
    params: query
  })
}

export function generalArchiveBankadd(obj) {
  return request({
    url: `/api/generalArchiveBank`,
    method: 'post',

    data: obj
  })
}



// 字典
export function dictionary(query) {
  return request({
    url: '/api/blade-system/dict-biz/dictionary',
    method: 'get',
    params: query
  })
}

// 总代档案新增
export function genArchiveRecord(obj) {
  return request({
    url: `/api/generalArchiveRecord`,
    method: 'post',
    data: obj
  })
}

export function genArchivePut(obj) {
  return request({
    url: `/api/generalArchiveRecord`,
    method: 'put',
    data: obj
  })
}
// 店铺档案新增
export function shopArchiveRecord(obj) {
  return request({
    url: `/api/shopArchiveRecord`,
    method: 'post',
    data: obj
  })
}

export function shopArchivePut(obj) {
  return request({
    url: `/api/shopArchiveRecord`,
    method: 'put',
    data: obj
  })
}

export function genArchiveUser(query) {
  return request({
    url: '/api/generalArchiveUser/baseinfo/by/generaluser',
    method: 'get',
    params: query
  })
}

export function shopArchiveUser(query) {
  return request({
    url: '/api/shopArchiveUser/baseinfo/by/shopuser',
    method: 'get',
    params: query
  })
}

export function regArchiveUser(query) {
  return request({
    url: '/api/areaArchiveUser/baseinfo/by/areauser',
    method: 'get',
    params: query
  })
}


export function genuser(query) {
  return request({
    url: '/api/generalArchive/baseinfo/by/generaluser',
    method: 'get',
    params: query
  })
}
export function shopuser(query) {
  return request({
    url: '/api/shopArchive/baseinfo/by/shopuser',
    method: 'get',
    params: query
  })
}
export function reguser(query) {
  return request({
    url: '/api/areaArchive/baseinfo/by/areauser',
    method: 'get',
    params: query
  })
}



// 总代用户批量修改
export function genArchiveUserbatchPut(obj) {
  return request({
    url: `/api/generalArchiveUserRecord/batch`,
    method: 'put',
    data: obj
  })
}
export function shopArchiveUserbatchPut(obj) {
  return request({
    url: `/api/shopArchiveUserRecord/batch`,
    method: 'put',
    data: obj
  })
}

// 总代用户修改
export function genArchiveUserPut(obj) {
  return request({
    url: `/api/generalArchiveUserRecord`,
    method: 'put',
    data: obj
  })
}

export function shopArchiveUserPut(obj) {
  return request({
    url: `/api/shopArchiveUserRecord`,
    method: 'put',
    data: obj
  })
}
// 总代审核
export function submitgencheck(obj) {
  return request({
    url: `/api/generalArchive/submit/check`,
    method: 'post',
    data: obj
  })
}
export function submitshopcheck(obj) {
  return request({
    url: `/api/shopArchive/submit/check`,
    method: 'post',
    data: obj
  })
}

// 厂家查看总代 区代 店铺档案


export function shopuserdetail(query) {
  return request({
    url: `/api/shopArchive/${query.id}`,
    method: 'get',

  })
}

export function generalArchivedetail(query) {
  return request({
    url: `/api/generalArchive/${query.id}`,
    method: 'get',

  })
}

export function areaArchivedetail(query) {
  return request({
    url: `/api/areaArchive/${query.id}`,
    method: 'get',

  })
}

export function shopArchiveUserdetail(query) {
  return request({
    url: `/api/shopArchiveUser/${query.id}`,
    method: 'get',

  })
}
export function generalArchiveUserdetail(query) {
  return request({
    url: `/api/generalArchiveUser/${query.id}`,
    method: 'get',

  })
}
export function areaArchiveUserdetail(query) {
  return request({
    url: `/api/areaArchiveUser/${query.id}`,
    method: 'get',

  })
}


// 审核按钮
export function shopArchivecheck(obj) {
  return request({
    url: `/api/shopArchive/check`,
    method: 'post',
    data: obj
  })
}

export function genArchivecheck(obj) {
  return request({
    url: `/api/generalArchive/check`,
    method: 'post',
    data: obj
  })
}

export function regArchivecheck(obj) {
  return request({
    url: `/api/areaArchive/check`,
    method: 'post',
    data: obj
  })
}


//厂家审核总代订单

export function factorygeneralItemOrdercheck(obj) {
  return request({
    url: `/api/generalItemOrder/check`,
    method: 'post',
    data: obj
  })
}
// 发货

export function factorygeneralItemOrdersend(obj) {
  return request({
    url: `/api/generalItemOrder/send`,
    method: 'post',
    data: obj
  })
}

// 分期付款
export function generalApplyDevicePage(query) {
  return request({
    url: '/api/instalmentApplyDevice/page',
    method: 'get',
    params: query
  })
}

export function generalApplyDevicePay(query) {
  return request({
    url: `/api/instalmentApplyDevice/pay-detail/${query.id}`,
    method: 'get',
    params: query
  })
}
export function maintenanceList(query) {
  return request({
    url: `/api/maintenance/list-maintenance`,
    method: 'get',
    params: query
  })
}



export function generalApplyDeviceInstall(query) {
  return request({
    url: `/api/instalmentApplyDevice/install-detail/${query.id}`,
    method: 'get',
    params: query
  })
}
export function generalApplyDeviceAdd(obj) {
  return request({
    url: `/api/instalmentApplyDevice`,
    method: 'post',
    data: obj
  })
}

export function generalApplyDeviceBind(query) {
  return request({
    url: `/api/instalmentApplyDevice/list-bind-maintenance`,
    method: 'get',
    params: query
  })
}
export function generalApplyDeviceBindmaintenance(obj) {
  return request({
    url: `/api/instalmentApplyDevice/bind-maintenance`,
    method: 'post',
    data: obj
  })
}

export function shopApplyDeviceConfirm(obj) {
  return request({
    url: `/api/shopApplyDevice/confirm?id=${obj.id}`,
    method: 'post',
    data: obj
  })
}

export function instalmentApplyDeviceConfirm(obj) {
  return request({
    url: `/api/instalmentApplyDevice/confirm`,
    method: 'post',
    data: obj
  })
}


export function generalApplyDeviceApply(obj) {
  return request({
    url: `/api/instalmentApplyDevice/apply-pay/${obj.id}/${obj.num}`,
    method: 'put',
    data: obj
  })
}
export function generalApplyDeviceFactory(obj) {
  return request({
    url: `/api/instalmentApplyDevice/factory-audit-pay/${obj.id}`,
    method: 'put',
    data: obj
  })
}

export function generalApplyDeviceauditFactory(obj) {
  return request({
    url: `/api/instalmentApplyDevice/factory-audit-install`,
    method: 'put',
    data: obj
  })
}

export function generalinstalmentApplyDeviceCheck(obj) {
  return request({
    url: `/api/instalmentApplyDevice/general/check`,
    method: 'post',
    data: obj
  })
}

export function generalinstalmentApplyDeviceSend(obj) {
  return request({
    url: `/api/instalmentApplyDevice/send`,
    method: 'post',
    data: obj
  })
}

export function shopArchiveBankList(query) {
  return request({
    url: '/api/shopArchiveBank/list',
    method: 'get',
    params: query
  })
}


export function shopApplyDevice(obj) {
  return request({
    url: `/api/shopApplyDevice`,
    method: 'post',
    data: obj
  })
}

export function shopApplyDeviceput(obj) {
  return request({
    url: `/api/shopApplyDevice`,
    method: 'put',
    data: obj
  })
}

// 取消订单
export function shopApplyDeviceClose(obj) {
  return request({
    url: `/api//shopApplyDevice/close`,
    method: 'post',
    data: obj
  })
}


